import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The ComparadorBiddingsDistributions component.
 */
const ComparadorBiddingsDistributions = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-Comparador-Licitaciones.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>
          Selecciona el tipo de distribución que deseas para los datos, puede ser monto en pesos, porcentaje o número de
          órdenes de compra.
        </Item>
        <Item>Selecciona el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.</Item>
        <Item>Eje correspondiente al tipo de distribución seleccionado</Item>
        <Item>Corresponde a la distribución de datos entre las distintas licitaciones según su monto</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default ComparadorBiddingsDistributions
